module.exports = __webpack_public_path__ + "img/fat-free-date-bread.69e1e244.jpg";